import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';
import {
  ApiResponse,
  DataLiquidateContainerBL,
} from '@/types/liquidateContainerBLType';

type Validated = {
  oidVisita: number;
  ingresoTardio: boolean;
  rut: string;
  fecha: string;
};

export const getLiquidateContainerBlExport = async (
  query: Validated
): Promise<DataLiquidateContainerBL> => {
  try {
    const res = await apiClient.post<ApiResponse>(
      Endpoints.LiquidateContainerBLExport,
      query
    );
    if (res?.data.value?.error) {
      throw new Error(res.data.value.error);
    }
    if (!res.data.isSuccess) {
      throw new Error('No se ha podido obtener el contenedor');
    }
    return res.data.value;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
